module.exports = __webpack_public_path__ + "images/2-ru.jpg?v=2e728a5745003cf295a8a5fba917f667";